import * as Cookies from 'js-cookie';
import { trackMotivationLayerClick } from '../../Tracking/GoogleTracking';

declare var __ucCmp: any;
const trboId = 'ryxCCtrEX';
const gtmId = 'BJ59EidsWQ';
const jentisId = 'V4QOOdntTmS07U';
const econdaId = 'SJXtq4iOoZX';

const closeMotivationLayer = () => {
    const allOverlays = document.querySelectorAll('.personalize-overlay');
    allOverlays.forEach(overlay => overlay.remove());

    Cookies.set('hideTrboMotivationLayer', 'true', { expires: 30 });
};

const handleUcInfoClick = (event: Event) => {
    const button = event.currentTarget as HTMLElement;
    const ucInfo = button.getAttribute('data-ucinfo');

    const templateIdMap: { [key: string]: string } = {
        trbo: trboId,
        gtm: gtmId,
        jentis: jentisId,
        econda: econdaId,
    };

    if (ucInfo && templateIdMap[ucInfo]) {
        __ucCmp.showServiceDetails(templateIdMap[ucInfo]);
    }
};

const handleUcAgreeClick = () => {
    __ucCmp.updateServicesConsents([
        { id: trboId, consent: true },
        { id: gtmId, consent: true },
        { id: jentisId, consent: true },
        { id: econdaId, consent: true },
    ]);
    __ucCmp.saveConsents();

    // Hide all personalize-overlay elements without setting cookie
    const allOverlays = document.querySelectorAll('.personalize-overlay');
    allOverlays.forEach(overlay => overlay.remove());

    trackMotivationLayerClick();
};

export const showMotivationLayerIfAllowed = (element: HTMLElement) => {
    const hideTrboMotivationLayer = Cookies.get('hideTrboMotivationLayer');

    if (hideTrboMotivationLayer !== 'true') {
        const overlayElement = element.querySelector('.personalize-overlay');
        if (overlayElement) {
            overlayElement.classList.remove('hide');

            // Add event listener for all close buttons
            const closeButtons = overlayElement.querySelectorAll('.close-btn');
            closeButtons.forEach(closeBtn => {
                closeBtn.addEventListener('click', closeMotivationLayer);
            });

            // Add event listener for all uc-info buttons
            const ucInfoButtons = overlayElement.querySelectorAll('.uc-info');
            ucInfoButtons.forEach(ucInfoBtn => {
                ucInfoBtn.addEventListener('click', handleUcInfoClick);
            });

            // Add event listener for uc-agree button
            const ucAgreeButton = overlayElement.querySelector('.uc-agree');
            if (ucAgreeButton) {
                ucAgreeButton.addEventListener('click', handleUcAgreeClick);
            }
        }
    } else {
        const overlayElement = element.querySelector('.personalize-overlay');
        if (overlayElement) {
            overlayElement.remove();
        }
    }
};
